import { customer } from '@icabbi/api-gateway-client';
import { Authentication } from '@icabbi/vue-authentication';

const defaultState = {
  driverStateQueryConnector: null,
  driverStates: [],
  driverStatesLoading: false,
};

const getters = {
  // eslint-disable-next-line no-shadow
  driverStateQueryConnector: (state, getters, rootState, rootGetters) => ({ dispatch }) => {
    if (state.driverStateQueryConnector === null) {
      const authentication = Authentication({ dispatch, getters: rootGetters });
      const { authenticationFailureInterceptor, bearerTokenInterceptor } = authentication;
      const driverStateQueryConnector = new customer.DriverStateQueryConnector({
        baseURL: process.env.VUE_APP_API_GATEWAY_URL,
        timeout: parseInt(process.env.VUE_APP_HTTP_REQUEST_TIMEOUT, 10),
      });
      driverStateQueryConnector.httpClient.interceptors.response.use(undefined, error => authenticationFailureInterceptor(error));
      driverStateQueryConnector.httpClient.interceptors.request.use(config => bearerTokenInterceptor(config));
      state.driverStateQueryConnector = driverStateQueryConnector;
    }
    return state.driverStateQueryConnector;
  },

};


const actions = {
  async getDriverStates(context) {
    try {
      context.commit('setDriverStatesLoading', true);
      const driverStateQueryConnector = context.getters.driverStateQueryConnector(context);

      const driverStates = await driverStateQueryConnector.getDriverStates({ });
      context.commit('setDriverStates', driverStates);
      context.commit('setDriverStatesLoading', false);
      return driverStates;
    } catch (error) {
      // eslint-disable-next-line no-console
      context.dispatch('globalMessages/addError', { message: 'driverStates.driverStateRetrievalError' }, { root: true });
      context.commit('setDriverStatesLoading', false);
      return false;
    }
  },
};

const mutations = {
  setDriverStates(state, driverStates) {
    state.driverStates = driverStates;
  },
  setDriverStatesLoading(state, driverStatesLoading) {
    state.driverStatesLoading = driverStatesLoading;
  },
};

export default {
  namespaced: true,
  state: defaultState,
  getters,
  actions,
  mutations,
};
